import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { debounceTime } from 'rxjs/operators';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class ProgramaService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'programa';
    this.token = new Login();
  }

  all(page = 1, buscar = '', paginate = 10){
    return this.http.get<Object[]>(this.url + '?page=' + page + '&q=' + buscar + '&paginate=' + paginate, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  search(buscar: any){
    return this.http.get<Object[]>(this.url+ '?q=' + buscar, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    }).pipe(debounceTime(5000));
  }

  criar(programa : any) {
    return this.http.post<Object[]>(this.url, programa, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
  
  ativar(idprograma: any){
    return this.http.get<Object[]>(this.url+ '/ativar/' + idprograma, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  inativar(idprograma: any){
    return this.http.get<Object[]>(this.url+ '/inativar/' + idprograma, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  atualizar(p : any) {
    return this.http.put<Object[]>(this.url + '/' + p.idprograma, p, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }


  detalhar(idprograma){
    return this.http.get<Object[]>(this.url + '/' + idprograma, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}
